export default __webpack_public_path__ + "static/media/AudiS5.d8020723.png";